import { getBidderLabels } from '~/src/dash/api/console-api';
import { ISessionState } from '~/src/dash/reducers/session-reducers';
import { IUserState } from '~/src/dash/reducers/user-reducers';
import { IMenuList } from '~/src/dash/types/menuList';
import { checkUserInfoMasked } from '~/src/dash/utils/roles';

export interface IBidderLabelsParams {
  publisher_id: string;
}

export interface IBidderLabel {
  ID: string;
  Name: string;
}

export interface IBidderLabel {
  BidderLabels: IBidderLabel[];
}

export const getBidderLabelsList = async (
  session: ISessionState,
  user: IUserState,
): Promise<Record<string, IMenuList>> => {
  try {
    const { bidder_labels } = await getBidderLabels({
      query: {
        publisher_id: session.publisher.ID,
      },
    });

    const bidderLabelsList: IMenuList = {};

    bidder_labels.forEach((bl) => {
      const ID = bl.ID;
      const title = checkUserInfoMasked(user.user) ? `demo_bidder_${ID}` : bl.Name;
      bidderLabelsList[ID] = {
        title,
        selected: false,
        ID,
      };
    });

    return { 'Bidder Labels': bidderLabelsList };
  } catch (err) {
    // Return an empty object under the correct key to maintain consistency
    return { 'Bidder Labels': {} };
  }
};
